import { NotificationsService } from '@services/notifications/notifications.service';
import { ModalDayService } from '@components/calendar/modal-day/modal-day.service';
import { ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ObservatoryService } from '@services/services.module';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-imputation-s2-s3',
  templateUrl: './imputation-s2-s3.component.html',
  styleUrls: ['./imputation-s2-s3.component.scss']
})
export class ImputationS2S3Component implements OnInit, OnDestroy {

  @Input() data;
  @Input() workingDay;

  dataCopy = [];
  sumHours: number = 0;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private observatoryService: ObservatoryService,
    private notification: NotificationsService,
    private modalDayService: ModalDayService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.dataCopy = Object.assign([], this.data);
  }

  addRow(): void {
    const item = new ImputationsData();
    this.dataCopy.push(item);
    // this.refreshData();
  }

  refreshData() {
    this.observatoryService.setData('imputationS2S3', this.dataCopy);
    this.refreshHours();
  }

  refreshHours() {
    this.sumHours = 0;
    this.dataCopy.forEach(element => {
      this.sumHours = this.sumHours + Number(element.hours);
    });
  }

  isEmpty(obj): boolean {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  deleterow(fila: ImputationsData): void {
    if (this.isEmpty(fila)) {
      const index: number = this.dataCopy.indexOf(fila);
      if (index !== -1) {
        this.dataCopy.splice(index, 1);
        this.refreshData();
      }
      return;
    //  } else if (!fila.activityTypeId || !fila.hours || !fila.projectId) {
    } else if (!fila.hours || !fila.projectId) {
      const index: number = this.dataCopy.indexOf(fila);
      if (index !== -1) {
        this.dataCopy.splice(index, 1);
        this.refreshData();
      }
      return;
    }

    if (this.dataCopy.find(m => m.imputationId === fila.imputationId)) {
      if (fila.imputationId) {
        this.subscriptions.push(
          this.modalDayService.deleteImputationSelected(fila).subscribe(data => {
            if (data.response === 'OK') {

              this.notification.setSuccess(this.translate.instant('CALENDARIO.REMOVE_IMPUT'));

              const index: number = this.dataCopy.indexOf(fila);
              if (index !== -1) {
                this.dataCopy.splice(index, 1);
              }
              this.observatoryService.setData('updateCalendar', true);
              this.refreshData();
              //  this.update.emit();
            }
          })
        );
      } else {
        const index: number = this.dataCopy.indexOf(fila);
        if (index !== -1) {
          this.dataCopy.splice(index, 1);
        }
        this.refreshData();
      }
    } else {
      this.notification.setError(this.translate.instant('CALENDARIO.ERROR_REMOVE'));
    }
  }

  /**
  * @name ngOnDestroy
  * @description Lifecycle hook
  */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
